import React, { useState } from "react";
import eyeIcon from "../../../assets/icons/eye.svg";
// import downloadIcon from "../../../assets/icons/arrow_down.svg";
import pdfIcon from "../../../assets/icons/pdfIcon.png";

const FilePreview = ({ fileURL, fileType, onPreview, isPreview }) => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  return fileURL ? (
    <div
      style={{
        position: "relative", // For positioning icons on top of the image
        width: `${isPreview ? "10rem" : "20rem"}`,
        height: `${isPreview ? "6rem" : "11rem"}`,
      }}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <img
        src={
          fileType === "pdf" || fileType === "application/pdf"
            ? pdfIcon
            : fileURL
        }
        alt="no image"
        style={{
          width: `${
            fileType === "pdf" || fileType === "application/pdf"
              ? "65%"
              : "100%"
          }`,
          height: "100%",
          filter: isHovered ? "blur(2px)" : "none",
          cursor: isHovered ? "pointer" : "default",
          transition: "filter 0.3s, cursor 0.3s",
        }}
        onClick={() => {
          onPreview({
            open: true,
            url: fileURL,
            fileType: fileType,
          });
        }}
      />
      {isHovered && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "1rem",
            backgroundColor: "rgba(0, 0, 0, 0.5)", // Semi-transparent background on hover
          }}
        >
          <img
            src={eyeIcon}
            alt="Preview Icon"
            style={{
              width: "2rem",
              height: "2rem",
              cursor: "pointer",
            }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent triggering the onClick of the image
              onPreview({
                open: true,
                url: fileURL,
                fileType: fileType,
              });
            }}
          />
        </div>
      )}
    </div>
  ) : null;
};

export default FilePreview;
